/* ============================================================
   BURL — dynamic product page (wired to Shopify {{ product }})
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* gallery */
  var mainImg = $('#mainImg');
  $$('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      $$('.thumb').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      var src = t.getAttribute('data-src');
      if (!mainImg) return;
      mainImg.style.opacity = '0';
      var pre = new Image();
      pre.onload = function () { mainImg.src = src; mainImg.style.opacity = '1'; };
      pre.src = src;
    });
  });

  /* lightbox: every product image, like Ashdeco's viewer (23/10/2026). Opens on the image shown; arrows, counter,
     Esc / left / right keys, a swipe on phones; a click on the dark background closes it. */
  var lightbox = $('#lightbox'), lightboxImg = $('#lightboxImg'), lbCount = $('#lightboxCount');
  var lbClose = $('#lightboxClose'), lbPrev = $('#lightboxPrev'), lbNext = $('#lightboxNext');
  var lbList = $$('.thumb').map(function (t) { var i = t.querySelector('img'); return { src: t.getAttribute('data-src'), alt: i ? i.alt : '' }; });
  if (!lbList.length && mainImg) lbList = [{ src: mainImg.src, alt: mainImg.alt }];
  var lbIdx = 0, lbOpener = null;
  function lbOpen() { return !!lightbox && lightbox.classList.contains('open'); }
  function lbShow(i) {
    if (!lbList.length || !lightboxImg) return;
    lbIdx = (i + lbList.length) % lbList.length;
    var item = lbList[lbIdx];
    if (lightboxImg.getAttribute('src') !== item.src) {
      lightboxImg.classList.add('is-loading');
      lightboxImg.onload = lightboxImg.onerror = function () { lightboxImg.classList.remove('is-loading'); };
      lightboxImg.src = item.src;
    }
    lightboxImg.alt = item.alt;
    if (lbCount) lbCount.textContent = (lbIdx + 1) + ' / ' + lbList.length;
    // The next and previous images load while this one is looked at.
    if (lbList.length > 1) [1, -1].forEach(function (d) { (new Image()).src = lbList[(lbIdx + d + lbList.length) % lbList.length].src; });
  }
  function openLb(at, opener) {
    if (!lightbox) return;
    var active = typeof at === 'number' ? at : $$('.thumb').indexOf($('.thumb.is-active'));
    lbOpener = opener || document.activeElement;
    lightbox.classList.toggle('is-single', lbList.length < 2);
    lbShow(active > -1 ? active : 0);
    lightbox.classList.add('open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (lbClose) lbClose.focus({ preventScroll: true });
  }
  function closeLb() {
    if (!lbOpen()) return;
    lightbox.classList.remove('open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lbOpener && lbOpener.focus) lbOpener.focus({ preventScroll: true });
  }
  var zoomBtn = $('#zoomBtn'); if (zoomBtn) zoomBtn.addEventListener('click', openLb);
  if (mainImg) mainImg.addEventListener('click', openLb);
  if (lbClose) lbClose.addEventListener('click', closeLb);
  if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbIdx - 1); });
  if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbIdx + 1); });
  if (lightbox) lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox || e.target.classList.contains('lightbox__stage')) closeLb();
  });
  document.addEventListener('keydown', function (e) {
    if (!lbOpen()) return;
    if (e.key === 'Escape') closeLb();
    else if (e.key === 'ArrowLeft' && lbList.length > 1) lbShow(lbIdx - 1);
    else if (e.key === 'ArrowRight' && lbList.length > 1) lbShow(lbIdx + 1);
    else if (e.key === 'Tab') {
      // Focus stays on the viewer's buttons while it is open.
      var f = [lbClose, lbPrev, lbNext].filter(function (b) { return b && b.offsetParent !== null; });
      if (!f.length) return;
      var at = f.indexOf(document.activeElement);
      e.preventDefault();
      f[(at + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
    }
  });
  // A sideways swipe on a phone: the next or the previous image.
  var lbTouch = null;
  if (lightbox) {
    lightbox.addEventListener('touchstart', function (e) {
      lbTouch = e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
    }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      if (!lbTouch || lbList.length < 2) return;
      var dx = e.changedTouches[0].clientX - lbTouch.x, dy = e.changedTouches[0].clientY - lbTouch.y;
      lbTouch = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) lbShow(lbIdx + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* desktop image wall like Ashdeco's (23/10/2026): a click on an image opens the viewer on it; "Show more" shows the rest */
  var wall = $('#galleryWall'), wallMore = $('#galleryMore');
  $$('.gallery__tile').forEach(function (t) {
    t.addEventListener('click', function () { openLb(+t.getAttribute('data-index'), t); });
  });
  if (wall && wallMore) wallMore.addEventListener('click', function () {
    var open = !wall.classList.toggle('is-collapsed');
    wallMore.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var first = $('.gallery__tile.is-extra', wall);
      if (first) first.focus({ preventScroll: true });
    } else {
      var r = wallMore.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) wallMore.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  });

  /* desktop: the shorter column stays in view beside the other; a column taller than the screen is pinned by its bottom
     edge, above the add-to-cart bar while that bar is shown */
  var wide = window.matchMedia ? window.matchMedia('(min-width: 981px)') : null;
  var pinCols = $$('.pdp > .gallery, .pdp > .info'), pinBar = $('#stickybar'), pinRaf = 0;
  function headBottom() {
    var hs = $$('.nav, header');
    for (var i = 0; i < hs.length; i++) {
      var p = getComputedStyle(hs[i]).position;
      if (p === 'fixed' || p === 'sticky') { var r = hs[i].getBoundingClientRect(); if (r.top > -2 && r.top <= 2 && r.bottom > 0) return Math.round(r.bottom); }
    }
    return 0;
  }
  function footTop() {
    if (!pinBar || !pinBar.classList.contains('show')) return window.innerHeight;
    return window.innerHeight - pinBar.offsetHeight - (parseFloat(getComputedStyle(pinBar).bottom) || 0);
  }
  function pin() {
    pinRaf = 0;
    var top = wide.matches ? headBottom() + 16 : null, foot = footTop();
    pinCols.forEach(function (col) {
      if (top === null) { col.style.removeProperty('--pin-top'); return; }
      var t = Math.round(Math.min(top, foot - col.offsetHeight - 16)) + 'px';
      if (col.style.getPropertyValue('--pin-top') !== t) col.style.setProperty('--pin-top', t);
    });
  }
  function pinSoon() { if (!pinRaf) pinRaf = window.requestAnimationFrame(pin); }
  if (wide && pinCols.length) {
    pin();
    window.addEventListener('resize', pinSoon);
    window.addEventListener('scroll', pinSoon, { passive: true });
    if (window.ResizeObserver) pinCols.forEach(function (col) { new ResizeObserver(pinSoon).observe(col); });
    if (pinBar && window.MutationObserver) new MutationObserver(pinSoon).observe(pinBar, { attributes: true, attributeFilter: ['class'] });
    if (wide.addEventListener) wide.addEventListener('change', pinSoon); else if (wide.addListener) wide.addListener(pinSoon);
  }

  /* ---- variants / options ---- */
  var variants = window.__variants || [];
  var prices = window.__prices || {};
  var optionEls = $$('.opt[data-option-index]');
  var selected = optionEls.map(function (el) {
    var active = $('.js-opt.is-active', el);
    return active ? active.getAttribute('data-value') : null;
  });

  function findVariant() {
    if (!variants.length) return null;
    return variants.filter(function (v) {
      return v.options.every(function (val, i) { return selected[i] == null || String(val) === String(selected[i]); });
    })[0] || null;
  }

  var variantIdEl = $('#variantId'), priceNow = $('#priceNow'), addPrice = $('#addPrice'),
      stickyPrice = $('#stickyPrice'), addBtn = $('#addBtn');

  function applyVariant() {
    var v = findVariant();
    if (!v) return;
    if (variantIdEl) variantIdEl.value = v.id;
    var p = prices[v.id] || {};
    if (priceNow && p.label) priceNow.textContent = p.label;
    if (addPrice && p.label) addPrice.textContent = p.label;
    if (stickyPrice && p.label) stickyPrice.textContent = p.label;
    if (addBtn) {
      var avail = p.avail !== false && v.available !== false;
      addBtn.disabled = !avail;
      if (!avail) addBtn.textContent = 'Sold out';
      else if (addPrice) { addBtn.innerHTML = 'Add to cart · <span id="addPrice">' + (p.label || '') + '</span>'; }
    }
  }

  $$('.js-opt').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.opt');
      var i = parseInt(btn.getAttribute('data-index'), 10);
      if (isNaN(i) && group) i = parseInt(group.getAttribute('data-option-index'), 10);
      if (isNaN(i)) return;
      $$('.js-opt', group).forEach(function (x) { x.classList.remove('is-active'); });
      btn.classList.add('is-active');
      selected[i] = btn.getAttribute('data-value');
      var lab = $('.opt-val', group); if (lab) lab.textContent = btn.getAttribute('data-value');
      applyVariant();
    });
  });

  /* quantity */
  var qty = 1, qtyVal = $('#qtyVal'), qtyInput = $('#qtyInput');
  function setQty(n) { qty = Math.max(1, Math.min(9, n)); if (qtyVal) qtyVal.textContent = qty; if (qtyInput) qtyInput.value = qty; }
  var qm = $('#qtyMinus'), qp = $('#qtyPlus');
  if (qm) qm.addEventListener('click', function () { setQty(qty - 1); });
  if (qp) qp.addEventListener('click', function () { setQty(qty + 1); });

  /* add to cart (AJAX) */
  var cartCount = $('#cartCount');
  var addForm = $('#addForm');
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { document.querySelectorAll('#cartCount, .nav__cart-count').forEach(function (el) { el.textContent = c.item_count; }); })
      .catch(function () {});
  }
  function flash(btn, msg) {
    if (!btn) return; var html = btn.innerHTML; btn.disabled = true; btn.textContent = msg;
    setTimeout(function () { btn.innerHTML = html; btn.disabled = false; }, 1700);
  }
  if (addForm) {
    addForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = findVariant() || variants[0];
      if (!v) { window.location.href = '/cart'; return; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        // 14/10/2026: gửi kèm lựa chọn bề mặt (properties[Surface]) như form Shopify gốc
        body: JSON.stringify((function () {
          var b = { id: v.id, quantity: qty }, props = {};
          $$('input[name^="properties["]:checked, input[type="hidden"][name^="properties["]', addForm).forEach(function (i) { props[i.name.slice(11, -1)] = i.value; });
          if (Object.keys(props).length) b.properties = props;
          return b;
        })())
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (res.ok) { if (window.showCartPopup) window.showCartPopup(res.d); refreshCart(); flash(addBtn, '✓ Added to cart'); }
          else { flash(addBtn, res.d.description || 'Unavailable'); }
        }).catch(function () { addForm.submit(); });
    });
  }
  var stickyAdd = $('#stickyAdd');
  if (stickyAdd) stickyAdd.addEventListener('click', function () {
    if (addForm) addForm.requestSubmit ? addForm.requestSubmit() : addForm.dispatchEvent(new Event('submit', { cancelable: true }));
  });

  /* wishlist */
  var wishBtn = $('#wishBtn');
  if (wishBtn) wishBtn.addEventListener('click', function (e) {
    e.preventDefault();
    this.classList.toggle('is-saved');
    this.textContent = this.classList.contains('is-saved') ? '♥ Saved to wishlist' : '♡ Save to wishlist';
  });

  /* sticky add bar */
  var stickybar = $('#stickybar');
  if (stickybar && addBtn) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting && en.boundingClientRect.top < 0) stickybar.classList.add('show');
        else stickybar.classList.remove('show');
      });
    }, { threshold: 0 }).observe(addBtn);
  }

  /* faq single-open */
  var faqs = $$('.faq details');
  faqs.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) faqs.forEach(function (o) { if (o !== d) o.open = false; }); }); });

  /* long description: show "read more" only when it actually overflows the clamp */
  var descBody = $('#descBody'), descToggle = $('#descToggle');
  if (descBody && descToggle) {
    if (descBody.scrollHeight > descBody.clientHeight + 8) {
      descToggle.hidden = false;
      descToggle.addEventListener('click', function () {
        var open = descBody.classList.toggle('open');
        descToggle.textContent = open ? 'Show less' : 'Read full description';
      });
    }
  }

  applyVariant();
})();
